// todo MATAN: remove this file or rename it

export const TALENTS_BASIC_INPUTS_NAME: { [key: string]: string } = {
  FIRST_NAME: 'firstname',
  LAST_NAME: 'lastname',
  EMAIL: 'email',
  PHONE: 'phone',
  CITY: 'city',
  STATE: 'state',
  COUNTRY: 'country',
};
// todo move to language file without duplications
export const Validations = {
  FirstName: {
    Required: {
      text: 'First Name is Required',
    },
  },
  LastName: {
    Required: {
      text: 'Last Name is Required',
    },
  },
  Email: {
    Required: {
      text: 'Email is Required',
    },
    Invalid: {
      text: 'Invalid email address',
    },
  },
  Phone: {
    Required: {
      text: 'Phone is Required',
    },
    Invalid: {
      text: 'Invalid phone format',
    },
  },
  City: {
    Required: {
      text: 'City is Required',
    },
  },
  State: {
    Required: {
      text: 'State is Required',
    },
  },
  Country: {
    Required: {
      text: 'Country is Required',
    },
  },
  SocialLink: {
    Required: {
      text: 'Social Link is Required',
    },
    Invalid: {
      text: 'Social Link must be url',
    },
  },
  Attributes: {
    Name: {
      Required: {
        text: 'Attribute Name is Required',
      },
    },
    Description: {
      Required: {
        text: 'Attribute Description is Required',
      },
    },
  },
  Skills: {
    Name: {
      Required: {
        text: 'Skill Name is Required',
      },
    },
    Level: {
      Required: {
        text: 0,
      },
      Message: {
        text: 'Skill Value is Required',
      },
    },
  },
};

export const DATE_FORMAT = {
  YEAR: 'yyyy',
};

export const MONTHS = [
  '', // 0 from beckend months is star from 1
  'January', // 1 e.t.c
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const MonthsEnum = {
  January: '0',
};

const YearEnum = {
  2020: '2020',
};

export const DEFAULT_EXPERIENCE_VALUE = {
  START_DATE_MONTH: MonthsEnum.January,
  START_DATE_YEAR: YearEnum[2020],
  END_DATE_MONTH: MonthsEnum.January,
  END_DATE_YEAR: YearEnum[2020],
};
